import { BenefitDTO, BikeleasingBenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class BikeleasingBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const bikeleasingDetails = activeBenefit.details as BikeleasingBenefitDetailsDTO;

    const hasBikeleasingUser = !!bikeleasingDetails.bikeleasingEmployeeInformation.length;
    const hasBikeleasingContract = !!bikeleasingDetails.bikeleasingContract.length;

    let descriptionKey: string | undefined;
    if (!hasBikeleasingUser) {
      descriptionKey = `benefitModule:benefit.${activeBenefit.benefit}.description.register`;
    } else if (!hasBikeleasingContract) {
      descriptionKey = `benefitModule:benefit.${activeBenefit.benefit}.description.order`;
    }

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/bikeleasing',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: descriptionKey,
      descriptionValues: { total: bikeleasingDetails.bikeleasingCondition.priceRestrictions?.maxTotalPurchasePriceForAllBikes },
      benefitProgress: bikeleasingDetails.bikeleasingEmployeeInformation.length ? 100 : 0,
    };
  }
}
